import guest from './rules/guest'
import user from './rules/user'

export default { guest, user }
